/** URL-safe slug from a title: "Lindt & Aare" → "lindt-and-aare". */
export function slugify(title: string) {
  return title
    .toLowerCase()
    .replace(/&/g, 'and')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}
